const ToasterMixin = {
  methods: {
    showToast(title, message, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
      });
    },
  },
};

export default ToasterMixin;
